<template>
    <div class="agent pt20 pl30 col666">
        <div class="searchbox flex f-between pr20 mb15">
            <div></div>
            <div class="flex f-align-center">
                <p class="f14 mr10">门店名称：</p>
                <div class="inputbox">
                    <el-input v-model="shopName" placeholder="请输入集团名称"></el-input>
                </div>
                <a href="javascript:;" @click="searchShop" class="searchbtn w100 text-center bg-green white ml15 f14">搜索</a>
            </div>
        </div>
        <p class="f14">
            <!-- 已分配激活码：<span class="green">{{totalCode}}</span>个  -->
            已分配屏幕：<span class="green">{{totalScreen}}</span>个</p>
        <div class="mb15 mt15 mr30">
            <template>
                <el-table :data="tableData" border slot="empty">
                    <el-table-column prop="shopName" label="门店名称">
                    </el-table-column>
                    <el-table-column prop="groupName" label="所属集团">
                        </el-table-column>
                    <el-table-column prop="agentName" label="所属经销商">
                    </el-table-column>
                    <el-table-column prop="allScreen" label="已分配屏幕">
                        <template slot-scope="scope">
                            <div class="">
                                {{scope.row.allScreen}}
                                <i class="el-icon-view green cur-p"  @click="screenDetailCode(scope.row)"></i>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="activeScreen" label="已使用屏幕"> 
                    </el-table-column>
                    <el-table-column label="操作" v-if="accountutil.isGroup()"> 
                        <template slot-scope="scope">
                            <p class="cur-p green" @click="giveScreen(scope.row)"> 分配屏幕</p>
                        </template>
                    </el-table-column>
                </el-table>
            </template>
            <div v-if="page.totalcount > 10">
                <template>
                    <div class="block pt20 text-right">
                        <el-pagination @current-change="curpage" :current-page="page.pageno" :page-size="page.pagesize" layout="total, prev, pager, next, jumper"
                            :total="page.totalcount">
                        </el-pagination>
                    </div>
                </template>
            </div>
        </div>
        <el-dialog title="查看已分配的屏幕" :visible.sync="allCodePage" :closeOnClickModal="false" @close="closeAllCodePage">
            <div class="mb15">
                <template>
                    <el-table :data="screenDetail" border slot="empty">
                        <el-table-column prop="MacAddress" label="Mac地址">
                        </el-table-column>
                        <el-table-column prop="time" label="分配时间">
                        </el-table-column>
                        <el-table-column prop="remark" label="备注">
                        </el-table-column>
                        <el-table-column label="操作" v-if="accountutil.isGroup()">
                            <template slot-scope="scope">
                                <p class="cur-p green" @click="recall(scope.row)"> 收回屏幕 </p>
                            </template>
                        </el-table-column>
                    </el-table>
                </template>
                <div v-if="screenPage.totalcount > 10">
                    <template>
                        <div class="block pt20 text-right">
                            <el-pagination @current-change="changepage" :current-page="screenPage.pageno" :page-size="screenPage.pagesize" layout="total, prev, pager, next, jumper"
                                :total="screenPage.totalcount">
                            </el-pagination>
                        </div>
                    </template>
                </div>
            </div>
        </el-dialog>
        <el-dialog title="分配屏幕" :visible.sync="screenNum" :closeOnClickModal="false">
            <p>给“<span class="green">{{currentName}}</span>”分配屏幕</p>
            <div class="mt15 tabBox">
                <template>
                    <el-table :data="screenNumDetail" border slot="empty" @select="selectFn" @select-all="selectFn">
                        <el-table-column type="selection" width="55">
                        </el-table-column>
                        <el-table-column prop="MacAddress" label="Mac地址">
                        </el-table-column>
                    </el-table>
                </template>
            </div>
            <p class="mt15">备注：</p>
            <el-input type="textarea" placeholder="备注" v-model="giveRemark"></el-input>
            <div class="text-center mt15">
                <p>分配屏幕数量：<span class="red">{{pids.length}}个</span></p>
                <a href="javascript:;" class="searchbtn w100 text-center bg-green white ml15 f14 mt10" @click="bindingstore">确 定</a>
            </div>
        </el-dialog>
        <el-dialog title="温馨提示" :visible.sync="resetpage" :closeOnClickModal="false">
            <p>确定收回 <span class="red">{{curretshopName}}</span> 门店Mac地址为： {{currentmac}} 的设备吗？</p>
            <div class="text-center mt15">
                <a href="javascript:;" class="searchbtn w100 text-center bg-green white ml15 f14 mt10" @click="cancelbindingstore">确 定</a>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                totalCode:0,
                totalScreen:0,
                soid:0,
                currentName:'',
                giveRemark:'',
                shopName:'',
                agentName:'',
                groupName:'',
                tableData:[],
                page:{},
                allCodePage:false,
                screenDetail:[],
                screenPage:{},
                screenNum:false,
                screenNumDetail:[],
                pids:[],
                currentBusinessid:0,
                currentpid:0,
                currentmac:'',
                curretshopName:'',
                resetpage:false,
            }
        },
        created(){
            let that = this;
            that.list();
            // that.getrolloutpropsnum();
        },
        methods:{
            screenDetailCode(val){
                var that = this;
                that.allCodePage = true;
                that.currentBusinessid = val.soid;
                that.curretshopName = val.shopName;
                if(!that.accountutil.isGroup()){
                    that.propsorderdetailtootherslist(1)
                }else{
                    that.storelistsbyowner(1)
                }
            },
            closeAllCodePage(){
                var that = this;
                that.allCodePage = false;
            },
            giveScreen(val) {
                var that = this;
                that.screenNum = true;
                that.soid = val.soid;
                that.currentName = val.shopName
                that.listsbyowner()
            },
            list(){
                let that =this;
                if (!that.accountutil.isGroup()){
                    that.agentlist(1)
                }else{
                    that.shoplist(1)
                    that.getrolloutpropsnum()
                }
            },
            agentlist(page){
                let that = this;
                let req = {
                    agentid:that.accountutil.getAgent().agentid,
                    // agentid:100008,
                    type:400,
                    page:{
                        pageno:page,
                        pagesize:10
                    }
                }
                that.tableData = []
                that.httputil.post({
                    that: that,
                    url: that.api.agentlist,
                    req: req,
                    xmsuccess: function (res) {
                        if(res.list){
                            for(let val of res.list){
                                let json = {
                                    soid:val.store.soid,
                                    shopName:val.store.name,
                                    groupName:val.agentsub.brand.name,
                                    agentName:val.agentsub.agent.name,
                                    allScreen:val.totaltransferprops?val.totaltransferprops:0,
                                    activeScreen:val.totalhasuseprops?val.totalhasuseprops:0,
                                }
                                that.tableData.push(json)
                            }
                        }
                        if(res.ownertransfercode){
                            that.totalCode = res.ownertransfercode
                        }
                        if(res.ownertransferprops){
                            that.totalScreen = res.ownertransferprops
                        }
                        that.page = res.page || {}
                    },
                    xmfail: function (res) {
                        that.$message({
                            message: res.result.reason,
                            type: 'warning'
                        });
                    } 
                });
            },
            shoplist(page){
                let that = this;
                let req = {
                    bid:that.accountutil.getBid(),
                    // bid:100051,
                    type:400,
                    page:{
                        pageno:page,
                        pagesize:10
                    }
                }
                that.tableData = []
                that.httputil.post({
                    that: that,
                    url: that.api.agentlist,
                    req: req,
                    xmsuccess: function (res) {
                        if(res.list){
                            for(let val of res.list){
                                let json = {
                                    soid:val.store.soid,
                                    shopName:val.store.name,
                                    groupName:val.agentsub.brand.name,
                                    agentName:val.agentsub.agent.name,
                                    allScreen:val.totaltransferprops?val.totaltransferprops:0,
                                    activeScreen:val.totalhasuseprops?val.totalhasuseprops:0,
                                }
                                that.tableData.push(json)
                            }
                        }
                        if(res.ownertransfercode){
                            that.totalCode = res.ownertransfercode
                        }
                        that.page = res.page || {}
                    },
                    xmfail: function (res) {
                        that.$message({
                            message: res.result.reason,
                            type: 'warning'
                        });
                    } 
                });
            },
            curpage(page){
                let that = this;
                if (!that.accountutil.isGroup()){
                    that.agentlist(page)
                }else{
                    that.shoplist(page)
                }
            },
            searchShop() {
               var that = this;

               if(that.shopName) {
                   that.doSearchShop();
               } else {
                   if (!that.accountutil.isGroup()){
                       that.agentlist(1)
                   }else{
                       that.shoplist(1)
                       that.getrolloutpropsnum()
                   }
               }
            },
            doSearchShop() {
                var that = this;

                var req = {
                    type: 400,
                    name: that.shopName,
                    page: {
                        pageno: 1,
                        pagesize: 10
                    }
                };

                if (!that.accountutil.isGroup()){
                    req.agentid = that.accountutil.getAgent().agentid;
                }else{
                    req.bid = that.accountutil.getBid();
                }

                that.tableData = [];

                that.httputil.post({
                    that: that,
                    url: that.api.agentsearch,
                    req: req,
                    xmsuccess: function (res) {
                        that.tableData = (res.list || []).map(function (val, index, array) {
                            return {
                                soid:val.store.soid,
                                shopName:val.store.name,
                                groupName:val.agentsub.brand.name,
                                agentName:val.agentsub.agent.name,
                                allScreen:val.totaltransferprops?val.totaltransferprops:0,
                                activeScreen:val.totalhasuseprops?val.totalhasuseprops:0,
                            }
                        });
                        if(res.ownertransfercode){
                            that.totalCode = res.ownertransfercode
                        }
                        if(res.ownertransferprops){
                            that.totalScreen = res.ownertransferprops
                        }
                        that.page = res.page || {}
                    },
                    xmfail: function (res) {
                        that.$message({
                            message: res.result.reason,
                            type: 'warning'
                        });
                    }
                });
            },
            propsordertootherslist(){
                let that = this;
                let req = {
                    type:1000,
                    fromtype:that.accountutil.isGroup()?300:200,
                    fromid:that.accountutil.isGroup()?that.accountutil.getBid():that.accountutil.getAgent().agentid,
                    totype:400,
                    toid:that.soid,
                    page:{
                        pageno:1,
                        pagesize:999
                    }
                }
                that.screenNumDetail = [];
                that.httputil.post({
                    that: that,
                    url: that.api.propsordertootherslist,
                    req: req,
                    xmsuccess: function (res) {
                        if(res.propsinfo) {
                            for (var i = 0; i < res.propsinfo.length; i++) {
                                var target = res.propsinfo[i];
                                var json = {
                                    pid: target.pid,
                                    MacAddress: target.sncode,
                                }
                                that.screenNumDetail.push(json)
                            }
                        }
                    },
                    xmfail: function (res) {
                        that.$message({
                            message: res.result.reason,
                            type: 'warning'
                        });
                    }
                });
                
            },
            selectFn(selection) {
                var that = this;
                var pid = [];
                if(selection.length > 0) {
                    for (let i = 0; i < selection.length; i++) {
                        pid.push(selection[i].pid)
                    }
                }
                that.pids = pid
            },
            //分配屏幕
            bindingstore() {
                var that = this;
                if(that.pids.length == 0) {
                    that.$message({
                        message: '请至少选择一个设备！',
                        type: 'warning'
                    });
                    return;
                }
                var req = {
                    soid: that.soid,
                    pidlist: that.pids,
                    remark: that.giveRemark
                }
                that.httputil.post({
                    that: that,
                    url: that.api.bindingstore,
                    req: req,
                    xmsuccess: function (res) {
                        that.$message({
                            message: '分配成功！',
                            type: 'success'
                        });
                        that.pids = [];
                        that.screenNum = false;
                        that.shoplist(1);
                        that.giveRemark = '';
                    },
                    xmfail: function (res) {
                        that.$message({
                            message: res.result.reason,
                            type: 'warning'
                        });
                    }
                });
            },
            getrolloutpropsnum(){
                let that = this;
                let req = {
                    businesstype:300,
                    businessid:that.accountutil.getBid(),
                }
                that.httputil.post({
                    that: that,
                    url: that.api.getrolloutpropsnum,
                    req: req,
                    xmsuccess: function (res) {
                       if(res.rolloutpropsnum){
                           that.totalScreen = res.rolloutpropsnum || 0
                       }
                    },
                    xmfail: function (res) {
                        that.$message({
                            message: res.result.reason,
                            type: 'warning'
                        });
                    }
                });
            },
            changepage(page){
                let that = this;
                if(!that.accountutil.isGroup()){
                    that.propsorderdetailtootherslist(page)
                }else{
                    that.storelistsbyowner(page)
                }
            },
            storelistsbyowner(page) {
                var that = this;
                var req = {
                    owner: that.currentBusinessid,
                    typeid: 1000,
                    ownertype: 400,
                    page: {
                        pageno: page,
                        pagesize: 10
                    }
                }
                that.screenDetail = []
                that.httputil.post({
                    that: that,
                    url: that.api.listsbyowner,
                    req: req,
                    xmsuccess: function (res) {
                        if(res.propsinfo) {
                            for (let val of res.propsinfo) {
                                let json = {
                                    pid: val.pid,
                                    MacAddress:val.sncode,
                                    remark: val.remark?val.remark:'',
                                    time: new Date(val.businesstime * 1000).format("yyyy/MM/dd HH:mm:ss")
                                }
                                that.screenDetail.push(json)
                            }
                        }
                        that.screenPage = res.page || {}
                    },
                    xmfail: function (res) {
                        that.$message({
                            message: res.result.reason,
                            type: 'warning'
                        });
                    }
                });
            },
            listsbyowner() {
                var that = this;
                var req = {
                    owner: that.accountutil.getBid(),
                    typeid: 1000,
                    ownertype: 300,
                    page: {
                        pageno: 1,
                        pagesize: 9999
                    }
                }
                that.screenNumDetail = [];
                that.httputil.post({
                    that: that,
                    url: that.api.listsbyowner,
                    req: req,
                    xmsuccess: function (res) {
                        if(res.propsinfo) {
                            for (var i = 0; i < res.propsinfo.length; i++) {
                                var target = res.propsinfo[i];
                                var json = {
                                    pid: target.pid,
                                    MacAddress: target.sncode,
                                }
                                that.screenNumDetail.push(json)
                            }
                        }
                    },
                    xmfail: function (res) {
                        that.$message({
                            message: res.result.reason,
                            type: 'warning'
                        });
                    }
                });
            },
            propsorderdetailtootherslist(page){
                let that = this;
                let req = {
                    type:1000,
                    totype:400,
                    toid:that.currentBusinessid,
                    page:{
                        pageno:page,
                        pagesize:10,
                    }
                }
                if(that.accountutil.isGroup()){
                    req.fromtyp = 300;
                    req.fromid = that.accountutil.getBid();
                }
                that.screenDetail = []
                that.httputil.post({
                    that: that,
                    url: that.api.propsorderdetailtootherslist,
                    req: req,
                    xmsuccess: function (res) {
                        if(res.propsorderdetail) {
                            for (let val of res.propsorderdetail) {
                                let json = {
                                    pid: val.props.pid,
                                    MacAddress:val.props.sncode,
                                    remark: val.remark?val.remark:'',
                                    time: new Date(val.createtime * 1000).format("yyyy/MM/dd HH:mm:ss")
                                }
                                that.screenDetail.push(json)
                            }
                        }
                        that.screenPage = res.page || {}
                    },
                    xmfail: function (res) {
                        that.$message({
                            message: res.result.reason,
                            type: 'warning'
                        });
                    }
                });
            },
            recall(val){
                let that = this;
                that.currentpid = val.pid;
                that.currentmac = val.MacAddress;
                that.resetpage = true;
            },
            cancelbindingstore(){
                let that = this;
                let req = {
                    bid:that.accountutil.getBid(),
                    pidlist:[that.currentpid]
                }
                that.httputil.post({
                    that: that,
                    url: that.api.cancelbindingstore,
                    req: req,
                    xmsuccess: function (res) {
                        that.$message({
                            message: '收回成功！',
                            type: 'success'
                        });
                        that.shoplist(1);
                        that.allCodePage = false;
                        that.resetpage = false;
                    },
                    xmfail: function (res) {
                        that.$message({
                            message: res.result.reason,
                            type: 'warning'
                        });
                    }
                });
            }
        }
    }
</script>
<style scoped>
    .searchbox{
        height: 40px;
    }
    .inputbox{
        width: 180px;
    }
    .searchbtn{
        border-radius: 10px;
        height: 35px;
        line-height: 35px;
        display: inline-block;
    }
</style>


// WEBPACK FOOTER //
// src/pages/shop.vue